import { graphql } from '~/lib/graphql'

export const CancelPolicyPolicies = graphql(`
  fragment CancelPolicyPolicies on CancelPolicyStructured {
    policies {
      __typename
      appliesToVisitorDecrement
      charge {
        __typename
        ... on CancelPolicyChargeRate {
          rate
        }
        ... on CancelPolicyChargeFee {
          fee
        }
      }
      ... on CancelPolicyItemDaysBefore {
        days
        time
      }
    }
  }
`)
